import { NgcCookieConsentConfig, NgcCookieConsentModule } from 'ngx-cookieconsent';
import { environment } from '../../environments/environment';

export const CookieConfig: NgcCookieConsentConfig = {
  cookie: {
    domain: environment.cookieDomain,
    expiryDays: 365,
    secure: true,
  },

  position: 'bottom-left',
  theme: 'classic',
  palette: {
    popup: {
      background: '#4868af',
      text: '#ffffff',
      link: '#ffffff',
    },
    button: {
      background: '#ffffff',
      text: '#25508e',
      border: 'transparent',
    },
  },
  type: 'info',
  content: {
    header: 'cookies used on the website',
    message: `This website uses cookies to improve your experience. <br/>See our <a href="https://www.kinnect.us/privacy-policy/" style="color:white;font-weight: 600;" >Privacy Policy</a> to learn more.`,
    dismiss: 'ACCEPT',
    deny: 'Refuse cookies',
    link: '',
    href: 'https://www.kinnect.us/privacy-policy/',
    policy: 'Cookie Policy',
    target: '_blank',
  },
};

export default CookieConfig;
